import Vue from 'vue';
import Router from 'vue-router';
// tslint:disable: quotemark

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () =>
        import(/* webpackChunkName: "main" */ './views/Main.vue'),
      children: [
        {
          path: 'noaccess',
          component: () =>
            import(/* webpackChunkName: "login" */ './views/NoAccess.vue')
        },
        {
          path: 'login',
          component: () =>
            import(/* webpackChunkName: "login" */ './views/Login.vue')
        },
        {
          path: 'setup2fa',
          component: () =>
            import(/* webpackChunkName: "setup2fa" */ './views/Setup2FA.vue')
        },
        {
          path: 'home',
          name: 'home',
          component: () =>
            import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
          path: '/manage/users',
          name: 'manage/users',
          component: () =>
            import(
              /* webpackChunkName: "manage-users" */ './views/manage/users/Overview.vue'
            )
        },
        {
          path: '/manage/users/:id',
          name: 'manage/usersdetail',
          component: () =>
            import(
              /* webpackChunkName: "manage-users-detail" */ './views/manage/users/Detail.vue'
            )
        },
        {
          path: '/manage/errorevents',
          name: 'manage/errorevents',
          component: () =>
            import(
              /* webpackChunkName: "manage-errorevents" */ './views/manage/errorevents/Overview.vue'
            )
        },
        {
          path: '/manage/errorevents/:id',
          name: 'manage/erroreventsdetail',
          component: () =>
            import(
              /* webpackChunkName: "manage-errorevents-detail" */ './views/manage/errorevents/Detail.vue'
            )
        },
        {
          path: '/manage/apievents',
          name: 'manage/apievents',
          component: () =>
            import(
              /* webpackChunkName: "manage-apievents" */ './views/manage/apievents/Overview.vue'
            )
        },
        {
          path: '/manage/apievents/:id',
          name: 'manage/apieventsdetail',
          component: () =>
            import(
              /* webpackChunkName: "manage-apievents-detail" */ './views/manage/apievents/Detail.vue'
            )
        },
        {
          path: '/sale/customers',
          name: 'sale/customers',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Klanten',
                disabled: false,
                href: '/sale/customers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-relations" */ './views/manage/relations/Overview.vue'
            )
        },
        {
          path: '/sale/customers/:id',
          name: 'sale/customersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Klanten',
                disabled: false,
                href: '/sale/customers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-relations-detail" */ './views/manage/relations/Detail.vue'
            )
        },
        {
          path: '/manage/unittypes',
          name: 'manage/unittypes',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Eenheden',
                disabled: false,
                href: '/manage/unittypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-unittypes" */ './views/manage/unittypes/Overview.vue'
            )
        },
        {
          path: '/manage/unittypes/:id',
          name: 'manage/unittypesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Eenheden',
                disabled: false,
                href: '/manage/unittypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-unittypes-detail" */ './views/manage/unittypes/Detail.vue'
            )
        },
        {
          path: '/manage/products',
          name: 'manage/products',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Artikelen',
                disabled: false,
                href: '/manage/products'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-products" */ './views/manage/products/Overview.vue'
            )
        },
        {
          path: '/manage/products/:id',
          name: 'manage/productsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Artikelen',
                disabled: false,
                href: '/manage/products'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-products-detail" */ './views/manage/products/Detail.vue'
            )
        },
        {
          path: '/manage/templates',
          name: 'manage/templates',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Templates',
                disabled: false,
                href: '/manage/templates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-templates" */ './views/manage/templates/Overview.vue'
            )
        },
        {
          path: '/manage/templates/:id',
          name: 'manage/templatesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Templates',
                disabled: false,
                href: '/manage/templates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-templates-detail" */ './views/manage/templates/Detail.vue'
            )
        },
        {
          path: '/projects',
          name: 'projects',
          meta: {
            breadCrumbs: [
              {
                text: 'Projecten',
                disabled: false,
                href: '/projects'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-projects" */ './views/projects/Overview.vue'
            )
        },
        {
          path: '/projects/:id',
          name: 'projectsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Projecten',
                disabled: false,
                href: '/projects'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-projects-detail" */ './views/projects/Detail.vue'
            )
        },
        {
          path: '/sale/templates',
          name: 'sale/templates',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Templates',
                disabled: false,
                href: '/sale/templates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-overview" */ './views/documents/Overview.vue'
            )
        },
        {
          path: '/sale/templates/:id',
          name: 'sale/templatedetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Templates',
                disabled: false,
                href: '/sale/templates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-detail" */ './views/documents/Detail.vue'
            )
        },
        {
          path: '/sale/quotes',
          name: 'sale/quotes',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Offertes',
                disabled: false,
                href: '/sale/quotes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-overview" */ './views/documents/Overview.vue'
            )
        },
        {
          path: '/sale/quotes/:id',
          name: 'sale/quotesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Offertes',
                disabled: false,
                href: '/sale/quotes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-detail" */ './views/documents/Detail.vue'
            )
        },
        {
          path: '/sale/orders',
          name: 'sale/orders',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Werkbonnen',
                disabled: false,
                href: '/sale/orders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-overview" */ './views/documents/Overview.vue'
            )
        },
        {
          path: '/sale/orders/:id',
          name: 'sale/ordersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Werkbonnen',
                disabled: false,
                href: '/sale/orders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-detail" */ './views/documents/Detail.vue'
            )
        },
        {
          path: '/sale/invoices',
          name: 'sale/invoices',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Facturen',
                disabled: false,
                href: '/sale/invoices'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-overview" */ './views/documents/Overview.vue'
            )
        },
        {
          path: '/sale/invoices/:id',
          name: 'sale/invoicesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: 'Facturen',
                disabled: false,
                href: '/sale/invoices'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-detail" */ './views/documents/Detail.vue'
            )
        },
        {
          path: '/sale/credit_notes',
          name: 'sale/credit_notes',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: "Kredietnota's",
                disabled: false,
                href: '/sale/credit_notes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-overview" */ './views/documents/Overview.vue'
            )
        },
        {
          path: '/sale/credit_notes/:id',
          name: 'sale/credit_notesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Verkoop',
                disabled: true
              },
              {
                text: "Kredietnota's",
                disabled: false,
                href: '/sale/credit_notes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "documents-detail" */ './views/documents/Detail.vue'
            )
        }
      ]
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
});
